import { PayloadAction } from '@reduxjs/toolkit';
import { put } from 'redux-saga/effects';

import * as API from 'services';

import { formatAssignmentHistoryLayerList } from './assignment-history-layer.helper';
import { AssignmentHistoryLayerActions } from './assignment-history-layer.redux';
import { IPayloadGetAssignmentHistoryLayerListRequest } from './assignment-history-layer.type';

export function* getAssignmentHistoryLayerList(
	action: PayloadAction<IPayloadGetAssignmentHistoryLayerListRequest>
) {
	const { franchiseId, callback } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.GetAssignmentHistoryLayerListResponse> =
			yield API.getAssignmentHistoryLayerList(franchiseId);
		const content = formatAssignmentHistoryLayerList(res?.data);

		yield put(
			AssignmentHistoryLayerActions.getAssignmentHistoryLayerListSuccess({
				content,
			})
		);

		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(
			AssignmentHistoryLayerActions.getAssignmentHistoryLayerListFailure()
		);
	}
}
